import { render, staticRenderFns } from "./InputMaskText.vue?vue&type=template&id=5934f32a&scoped=true"
import script from "./InputMaskText.vue?vue&type=script&lang=js"
export * from "./InputMaskText.vue?vue&type=script&lang=js"
import style0 from "./InputMaskText.vue?vue&type=style&index=0&id=5934f32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934f32a",
  null
  
)

export default component.exports